import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'; // Import WhatsApp icon

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  // Listen to scroll events
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const navigate = useNavigate(); // Hook for navigation

  const goToHome = () => {
    navigate('/'); // Navigate to the / route
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white bg-opacity-50 backdrop-blur-md shadow-md' // White background with opacity and blur when scrolled
          : 'bg-white bg-opacity-50 backdrop-blur-md' // White background with opacity and blur by default
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-6 py-4">
        {/* Left Section: Logo and Brand Name */}
        <div className="flex items-center space-x-1" onClick={goToHome}>
          {/* Logo */}
          <img
            src="/images/logoend.png" // Replace with your logo file path
            alt="Logo best interior designers in Hyderabad"
            className="w-10 h-10 rounded-full cursor-pointer"
            onClick={goToHome}
          />
          {/* Brand Name */}
          <h1 className="text-l font-bold text-gray-800 cursor-pointer">Grow Home Studio</h1>
        </div>

        {/* Right Section: WhatsApp Icon */}
        <div className="flex items-center space-x-4">
          {/* WhatsApp Icon */}
          <a
            href="https://wa.me/+916303619305" // Replace with your WhatsApp phone number
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#25d366] hover:text-[#128c7e] transition-colors"
          >
            <FontAwesomeIcon icon={faWhatsapp} size="2x" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
